import { CSSProperties } from 'react';
import { Skeleton } from '@material-ui/lab';
import { Box } from '@material-ui/core';
import { CustomLogo } from './CustomLogo';
import { DefaultLogo } from './DefaultLogo';
import IconLogo from './IconLogo';
import { useLogos } from './hooks/useLogos';
import demoBadge from './demo-badge.png';

type LogoProps = {
  full?: boolean;
  style?: CSSProperties;
  hidePoweredBy?: boolean;
  showDemoBadge?: boolean;
};

export const Logo = ({
  full = true,
  style,
  hidePoweredBy = false,
  showDemoBadge = false,
}: LogoProps) => {
  const { data: logos, isLoading } = useLogos();

  if (isLoading) {
    return (
      <Skeleton style={{ minWidth: '190px' }} width="100%" height="100%" />
    );
  }

  const renderLogo = () => {
    if (!full) {
      return <IconLogo customIconLogo={logos?.iconLogo} style={style} />;
    }
    if (logos?.fullLogo) {
      return (
        <CustomLogo customLogo={logos.fullLogo} hidePoweredBy={hidePoweredBy} />
      );
    }
    return <DefaultLogo style={style} />;
  };

  if (!showDemoBadge) {
    return renderLogo();
  }

  // show logo with demo badge next to it
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Box style={{ flex: 1, minWidth: 0, height: '100%' }}>{renderLogo()}</Box>
      <img
        src={demoBadge}
        alt=""
        style={{
          height: '40px',
          width: 'auto',
          pointerEvents: 'none',
          flexShrink: 0,
        }}
      />
    </Box>
  );
};
